import React from "react";
import styled from "styled-components";

import Menu from "../../../../components/Menu";
import ContentDash from "../../../DashPaciente/ContentDash";

const EditarPerfilController: React.FC = () => {
	return (
		<ViewPort>
			<Menu></Menu>
			<ContentDash listagem={"editarPerfil"} />
		</ViewPort>
	);
};

export const ViewPort = styled.div`
	display: flex;
`;

export default EditarPerfilController;
